import React, { FC } from 'react'
import styled, { css, keyframes } from 'styled-components'
import { useSelector } from 'react-redux'
import { formValueSelector } from 'redux-form'

import { translate } from 'loankeeper-common/helpers'

const pulse = keyframes`
  0% {
    opacity: 1;
  }

  1% {
    opacity: 0;
  }
`

const animation = () =>
  css`
    ${pulse} 4s linear 2s infinite;
  `

const StyledWarning = styled.span`
  background-color: red;
  color: white;
  padding: 5px;
  animation: ${animation};
`

const WarningMessages: FC<{ FormName: string }> = ({ FormName }) => {
  const selectFormValue = formValueSelector(FormName)

  const showCommercialWarning: boolean = useSelector((state) => selectFormValue(state, 'ccyCommercialRateNotFound'))
  const showOfficalWarning: boolean = useSelector((state) => selectFormValue(state, 'ccyOfficalRateNotFound'))

  return (
    <>
      {showCommercialWarning && (
        <StyledWarning className="u-marginRight-10">{translate('frm_acc_conv_add-pan_no_isocommrate')}</StyledWarning>
      )}
      {showOfficalWarning && <StyledWarning>{translate('frm_acc_conv_add-pan_no_isorate')}</StyledWarning>}
    </>
  )
}

export const CommercialWarning = () => <StyledWarning>{translate('frm_acc_conv_add-pan_no_isocommrate')}</StyledWarning>

export default WarningMessages
